<template>
  <div class="contract-bd" v-if="funcView.contract_signed">
    <div class="tab-box">
      <el-form :inline="true" @submit.native.prevent class="form-screen">
        <el-form-item style="float: right; margin-right: 0">
          <i class="icon icon-shaixuan icon-filter" @click="isFilter = !isFilter"></i>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('contract.he_tong_bian_hao')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
      </el-form>
    </div>

    <!-- 过滤 -->
    <div class="query-filter" style="margin-top:24px" v-if="isFilter">
      <div class="params-form">
        <el-row :gutter="23">
          <el-col :span="8" v-if="userInfo.rootOrgId">
            <div class="item">
              <div class="label">{{ $t('Common.com_location') }}</div>
              <div class="value">
                <custom-select
                  :listener="`${userInfo.rootOrgId || 'null'}`"
                  url="LocationTagSelect"
                  :model="formSearch"
                  v-model="formSearch.locationId"
                  :params="{ orgId: userInfo.rootOrgId }"
                  :props="{ label: 'locationName', value: 'locationId', map: { locationName: 'locationName' } }"
                  :placeholder="$t('Common.com_please_select')"
                  :dataFilter="dataFilter"
                  @getList="getTagsList"
                  @change="onPageChange({ page: 1 })"
                >
                </custom-select>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="item">
              <div class="label">{{ $t('contract.jfsqdb') }}</div>
              <div class="value">
                <el-input v-model="formSearch.partyAName" @input="onPageChange({ page: 1 })" clearable :placeholder="$t('Common.com_please_input')"></el-input>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="filter-values">
        <div class="label">{{ $t('Common.com_filter_item') }}</div>
        <div class="values">
          <el-tag
            v-if="formSearch.locationId"
            closable
            @close="
              formSearch.locationId = '';
              formSearch.locationName = '';
            "
          >
            {{ formSearch.locationName }}
          </el-tag>
          <el-tag v-if="formSearch.partyAName" closable @close="formSearch.partyAName = ''">
            {{ formSearch.partyAName }}
          </el-tag>

          <span class="clear" @click="onClear">{{ $t('Common.com_clear') }}</span>
        </div>
      </div>
    </div>

    <!-- 已签署 -->
    <div class="table-bd">
      <ul class="table-head">
        <li class="num">
          <span class="num-th">{{ $t('contract.he_tong_zhuang_tai') }}</span>
        </li>
        <li class="date">
          <span>{{ $t('contract.qian_ding_ri_qi') }}</span>
        </li>
        <li class="amount">
          <span>{{ $t('contract.he_tong_bian_hao') }}</span>
        </li>
        <!-- 新 -->
        <li class="amount">
          <span>{{ $t('contract.he_tong_lei_xing') }}</span>
        </li>
        <li class="amount">
          <span>{{ $t('contract.qian_ding_fang_shi') }}</span>
        </li>
        <li class="authorized">
          <span>{{ $t('contract.jfsqdb') }}</span>
        </li>
        <!-- <li class="date">
          <span>签署截止日期</span>
        </li> -->
        <li class="project">
          <span>{{ $t('Common.com_location') }}</span>
        </li>
        <li class="action"></li>
      </ul>
      <ul class="table-body">
        <template v-if="tableList.length > 0">
          <li class="line" v-for="(item, index) in tableList" :key="index">
            <ul class="content">
              <li class="num">
                <div class="num-info">
                  <i class="icon icon-hetong"></i>
                  <div class="text">
                     <p>{{ getDicValue('crm_contract_biz_state', item.orderBizState) || '-' }}</p>
                  </div>
                </div>
              </li>
              <li class="date">
                <span>{{ $momentLocal(item.signingDate,'YYYY-MM-DD') }}</span>
              </li>
              <li class="amount">
                <p >{{ item.contractNo || '-' }}</p>
              </li>
              <!-- <li class="num">
                <div class="num-info">
                  <i class="icon icon-hetong"></i>
                  <div class="text">
                    <p v-if="item.bizClassType === 'contract'">{{ item.contractNo || '-' }}</p>
                    <p v-if="item.bizClassType === 'order'">{{ item.orderCode || '-' }}</p>
                  </div>
                </div>
              </li> -->

              <li class="amount">
                <span>{{ getDicValue('crm_contract_type', item.orderType) || '-' }}</span>
              </li>

              <li class="amount">
                <span>{{ getDicValue('signing_method', item.signingMethod) || '-' }}</span>
              </li>
              <li class="authorized">
                <span>{{ item.partyAName || '-' }}</span>
              </li>
              <!-- <li class="date">
                <span>{{ $momentFormat(item.signingexpiretime, 'YYYY-MM-DD') }}</span>
              </li> -->
              <li class="project">
                <span>{{ item.locationName || '-' }}</span>
              </li>
              <li class="action">
                <el-button type="text" size="mini" v-if="funcView.contract_detail" @click="onJumpDetails(item)">{{ $t('contract.he_tong_xiang_qing') }}</el-button>
                <i class="open icon icon-tianjia" v-if="isOpenIndex !== index" @click="openDetails(index, item)"></i>
                <i class="close icon icon-guanbi1" v-if="isOpenIndex === index" @click="closeDetails(index)"></i>
              </li>
            </ul>
            <div class="device-content" v-if="isOpenIndex === index">
              <ul class="device-content-head">
                <li class="product-code">
                  <span class="product-code-th">{{ $t('Common.com_model_no') }}</span>
                </li>
                <li class="quantity">
                  <span>{{ $t('contract.shu_liang') }}</span>
                </li>
                <li class="rent-set">
                  <span>{{$t('contract.zu_jin_tai')}}</span>
                </li>
                <li class="lease-time">
                  <span>{{ $t('contract.zu_lin_shi_chang') }}</span>
                </li>
                <li class="payment-cycle">
                  <span>{{ $t('contract.fu_kuan_zhou_qi') }}</span>
                </li>
                <li class="payment-periods">
                  <span>{{ $t('contract.fu_kuan_qi_shu') }}</span>
                </li>
                <li class="rent-period">
                  <span>{{$t('contract.zu_jin_tai_qi')}}</span>
                </li>
                <li class="deposit">
                  <span>{{$t('contract.ya_jin_tai')}}</span>
                </li>
              </ul>
              <ul class="device-content-body">
                <template v-if="schemeList.length > 0">
                  <li class="line" v-for="item in schemeList" :key="item.orderId">
                    <ul class="device-content-body-content">
                      <li class="product-code">
                        <!-- <span class="product-code-th">产品型号</span> -->
                        <div class="product-code-info">
                          <img :src="getAttachUrl(item)" />
                          <!-- <img
                            v-if="item.attachPath"
                            :src="item.attachPath"
                            alt
                          /> -->
                          <div class="text">
                            <p>{{ item.productCode }}</p>
                            <!-- <span>拖地机</span> -->
                          </div>
                        </div>
                      </li>
                      <li class="quantity">
                        <span>{{ item.bookingNum }}</span>
                      </li>
                      <li class="rent-set">
                        <!-- 租金每台 单价+附加费 -->
                        <span>{{ item.unitPrice + item.additionalFee }}</span>
                      </li>
                      <li class="lease-time">
                        <span>{{ item.rentalTerm }}{{ getDicValue('rental_term_unit', item.rentalTermUnit) }}</span>
                      </li>
                      <li class="payment-cycle">
                        <span>{{ getDicValue('crm_payment_period', item.paymentPeriod) }}</span>
                      </li>
                      <li class="payment-periods">
                        <span>{{ item.periodNum }}</span>
                      </li>
                      <li class="rent-period">
                        <span>{{ item.firstRent }}</span>
                      </li>
                      <li class="deposit">
                        <span>{{ item.depositFee }}</span>
                      </li>
                    </ul>
                  </li>
                </template>
              </ul>
            </div>
          </li>
        </template>
        <template v-else>
          <li class="no-data">{{ $t('Common.com_no_data') }}</li>
        </template>
      </ul>
      <div class="table-footer">
        <custom-pagination radius :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  name: 'contract',
  components: {},
  data() {
    return {
      totalRows: null,
      formSearch: {
        search: '',
        pageNum: 1,
        pageSize: 50,
        orgId: '',
        locationId: '',
        locationName: '',
        type: '',
        partyAName: ''
      },
      isFilter: false,
      tagId: '',
      tags: [],
      contractBizClass: ['20', '21', '30'], // 合同类型的bizClass
      orderBizClass: ['10', '31'], // 订单类型的bizClass
      tableList: [],
      isOpenIndex: '',
      schemeList: [],
      contractCountInfo: {}
    };
  },
  mounted: function () {
    this.getFuncView(null, () => {
      if (this.funcView.contract_signed) {
        this.formSearch.type = '2';
      }
      this.getTableList();
    });
    this.getContractCount();
  },
  methods: {
    onTabChange() {
      this.schemeList = [];
      this.isOpenIndex = null;
      this.onPageChange({ page: 1 });
    },
    // 获取标列表
    getTagsList(list) {
      const arr = [];
      list.forEach((item) => {
        const isHas = arr.find(t => t.tagId === item.tagId);
        if (!isHas && item.tagId && item.tagName) {
          arr.push({
            tagId: item.tagId,
            tagName: item.tagName
          });
        }
      });
      this.tags = arr;
    },
    // 点击标签
    onItemTag(tagId) {
      if (tagId === this.tagId) {
        this.tagId = '';
      } else {
        this.tagId = tagId;
      }
    },
    // 过滤图标
    dataFilter: function (list) {
      if (!this.tagId) {
        return list;
      }
      return list.filter(t => t.tagId === this.tagId);
    },
    onClear() {
      this.formSearch.locationId = '';
      this.formSearch.locationName = '';
      this.formSearch.partyAName = '';
      this.onPageChange({ page: 1 });
    },
    // 打开第三方签署地址
    sign(url) {
      window.open(url);
    },
    openDetails(index, item) {
      this.isOpenIndex = index;
      this.getSchemeList(item);
    },
    closeDetails() {
      this.schemeList = [];
      this.isOpenIndex = null;
    },
    // 合同详情
    onJumpDetails(item) {
      this.jump('/rent/contract/accountContractDetail', {
        contractId: item.orderId,
        contractClass: item.orderType
      });
    },
    getSchemeList(item) {
      // orderId作为bizId    orderType作为bizClass
      const params = {
        bizId: item.orderId,
        bizClass: item.orderType
      };
      this.$getJSON(apis.crmContractListScheme, params).then((res) => {
        const list = res.data.goodsList || [];
        if (list.length > 0) {
          this.formatAttachList(list, 'productCodeId', 'dms.product.icon')
            .then((result) => {
              this.schemeList = result;
            })
            .catch(() => {
              this.schemeList = list;
            });
        }
      });
    },
    getTableList() {
      this.$getJSON(apis.portalContractPage, this.formSearch).then((res) => {
        const data = res.data.list || [];
        data.forEach((item) => {
          if (this.contractBizClass.includes(`${item.orderType}`)) {
            item.bizClassType = 'contract';
          }
          if (this.orderBizClass.includes(`${item.orderType}`)) {
            item.bizClassType = 'order';
          }
        });
        this.tableList = data;
        this.totalRows = res.data.total;
      });
    },
    getContractCount() {
      this.$getJSON(apis.PortalContractCount).then((res) => {
        const data = res.data;
        this.contractCountInfo = data;
        // if (this.contractCountInfo.unSignNum > 0 && this.funcView.contract_unsigned) {
        //   this.formSearch.type = '1';
        // }
        // this.getTableList();
      });
    },
    onPageChange({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.isEditfloor = false;
      this.getTableList();
    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';
.contract-bd {
  padding-left: 24px;
  padding-right: 24px;
  .tab-box {
    padding-top: 24px 0;
    .form-screen {
      overflow: hidden;
      line-height: 40px;
    }
    .icon-filter {
      display: inline-block;
      text-align: center;
      box-sizing: border-box;
      font-size: 14px;
      width: 40px;
      height: 40px;
      color: $--color-text-primary;
      box-shadow: 0 0 0 1.5px #202945 inset;
      border-radius: 50px;
      cursor: pointer;
    }
  }

  .filter-box {
    height: 30px;
    line-height: 30px;
    display: flex;
    align-items: center;
    margin-top: 24px;
    .lable {
      font-weight: bold;
      font-size: 12px;
      margin-right: 16px;
      color: $--color-text-secondary;
    }
    .condition {
      margin-right: 8px;
      padding: 0 12px 0 16px;
      font-weight: bold;
      font-size: 12px;
      color: $--color-text-regular;
      cursor: pointer;
      .icon {
        font-size: 12px;
        color: $--color-primary;
        margin-left: 10px;
      }
    }
    .clear-btn {
      font-weight: bold;
      font-size: 12px;
      color: $--color-text-primary;
      height: 30px;
      line-height: 30px;
      text-align: center;
      padding: 0 14px !important;
      display: flex;
      align-items: center;
      // padding: 6.5px 14px;
    }
  }

  // 表格
  .table-bd {
    margin-top: 24px;
    width: 100%;
    // 表头
    .table-head {
      height: 64px;
      line-height: 64px;
      display: flex;
      background-color: #fff;
      border-radius: 16px;
      li {
        padding-left: 10px;
        // text-align: center;
        color: $--color-text-secondary;
        box-sizing: border-box;
        span {
          font-weight: bold;
          font-size: 14px;
          color: $--color-text-secondary;
        }
        &.num {
          .num-th {
            padding-left: 66px;
            text-align: left;
          }
        }
        &.payment {
          align-self: center;
          .payment-th {
            align-self: center;
            .title {
              color: $--color-text-secondary;
              font-weight: bold;
              font-size: 12px;
              line-height: 17px;
            }
            .sub-title {
              font-size: 12px;
              color: #818181;
              line-height: 17px;
            }
          }
        }
      }
    }
    // 内容
    .table-body {
      // height: 80px;
      // line-height: 80px;

      // align-content: center;
      .content {
        cursor: pointer;
        margin-top: 16px;
        height: 80px;
        line-height: 80px;
        display: flex;
        // flex-direction: column;
        background-color: #fff;
        border-radius: 16px;
        align-content: center;
        // padding-right: 24px;
        li {
          box-sizing: border-box;
          padding-left: 10px;
          color: $--color-text-secondary;
          overflow: hidden; /* 确保超出的文本被裁剪 */
          white-space: nowrap; /* 确保文本在一行内显示 */
          text-overflow: ellipsis; /* 超出的文本显示为省略号 */
          // text-align: center;
          span {
            color: $--color-text-regular;
            font-size: 14px;
          }
        }
      }
    }
    // 无数据
    .no-data {
      margin-top: 24px;
      height: 130px;
      text-align: center;
      line-height: 130px;
      font-size: 16px;
      color: #818181;
      background: #ffffff;
      border-radius: 16px;
    }
    // 列占比
    .num {
      width: 0;
      flex: 5;
      .num-info {
        padding-left: 25px;
        height: 80px;
        display: flex;
        align-items: center;
        font-size: 0;
        i {
          color: $--color-primary;
          font-size: 22px;
          margin-right: 18px;
        }
        .text {
          align-self: center;
          display: flex;
          // align-items: center;
          flex-direction: column;
          p {
            // font-weight: bold;
            font-size: 14px;
            line-height: 20px;
            color: $--color-text-regular;
          }
          span {
            font-size: 12px;
            line-height: 17px;
            text-align: left;
            color: $--color-text-secondary;
          }
        }
      }
      // width: 330px;
    }
    .amount {
      // width: 292px;
      width: 0;
      flex: 3;
      // width: 200px;
      text-align: left !important;
    }
    .payment {
      width: 0;
      flex: 3;
      text-align: left !important;
    }
    .date {
      width: 0;
      flex: 3;
      text-align: center;
      padding: 0 !important;
      margin-right: 30px;
    }
    .authorized {
      width: 0;
      flex: 6;
      text-align: left !important;
    }
    .project {
      width: 0;
      flex: 6;
      // text-align: center;
      // padding: 0 !important;
      margin-right: 30px;
    }
    .action {
      align-self: center;
      width: 0;
      flex: 6;
      // with: 300px;
      text-align: left !important;
      display: flex;
      button {
        margin-right: 24px;
      }
      span {
        color: $--color-primary !important;
      }
      i {
        flex: 0 0 40px;
        margin-left: auto;
        margin-right: 40px;
        font-size: 14px;
        width: 40px;
        height: 40px;
        line-height: 40px;
        color: #7b7f93;
        cursor: pointer;
        // box-sizing: border-box;
        border-radius: 50%;
        border: 1.5px solid $--color-text-primary;
        display: inline-block;
        text-align: center;
      }
      .open {
        color: $--color-text-primary;
        border-color: $--color-text-primary;
      }
      .close {
        color: $--color-text-primary;
        background-color: $--color-warning;
        border-color: $--color-warning;
      }
    }

    // 设备列表
    .device-content {
      margin-top: 8px;
      background-color: #fff;
      padding: 16px 32px 24px;
      border-radius: 16px;
      transition: all 0.5s;
      // 表头
      .device-content-head {
        height: 48px;
        line-height: 48px;
        display: flex;
        background-color: #fff;
        border-radius: 16px;
        box-shadow: inset 0px -1px 0px #f0f0f0;
        li {
          padding-left: 10px;
          text-align: center;
          color: $--color-text-secondary;
          box-sizing: border-box;
          span {
            font-weight: bold;
            font-size: 12px;
            color: $--color-text-secondary;
          }
          &.product-code {
            text-align: left;
          }
        }
      }

      // 内容
      .device-content-body {
        // height: 80px;
        // line-height: 80px;
        .line {
          background-color: #fff;
          border-radius: 16px;
          &:nth-child(even) {
            background: #f8f9fa;
          }
        }
        // align-content: center;
        .device-content-body-content {
          cursor: pointer;
          height: 80px;
          line-height: 80px;
          display: flex;
          // flex-direction: column;

          border-radius: 16px;
          align-content: center;
          li {
            box-sizing: border-box;
            padding-left: 10px;
            color: $--color-text-secondary;
            text-align: center;
            span {
              font-size: 14px;
              color: $--color-text-regular;
            }
          }
        }
      }
      // 列比例
      .product-code {
        width: 0;
        flex: 4;
        .product-code-info {
          padding-left: 16px;
          height: 80px;
          display: flex;
          align-items: center;
          font-size: 0;
          img {
            max-width: 40px;
            max-height: 40px;
            text-align: center;
            border-radius: 8px;
            margin-right: 16px;
          }
          .text {
            align-self: center;
            display: flex;
            // align-items: center;
            flex-direction: column;
            p {
              // font-weight: bold;
              font-size: 14px;
              line-height: 20px;
              color: $--color-text-regular;
            }
            span {
              font-size: 12px;
              line-height: 17px;
              text-align: left;
              color: $--color-text-secondary;
            }
          }
        }
      }
      .quantity {
        width: 0;
        flex: 3;
        // width: 200px;
        // text-align: left !important;
      }
      .rent-set {
        width: 0;
        flex: 3;
      }
      .lease-time {
        width: 0;
        flex: 3;
      }
      .payment-cycle {
        width: 0;
        flex: 3;
      }
      .payment-periods {
        width: 0;
        flex: 3;
      }
      .rent-period {
        width: 0;
        flex: 3;
      }
      .deposit {
        width: 0;
        flex: 6;
      }
    }
  }
  .table-footer {
    margin-top: 16px;
  }
}
</style>
